module.exports = __webpack_public_path__ + "img/51vs36.245a8643.png";